import { render, staticRenderFns } from "./ProcessTableRow.vue?vue&type=template&id=4579e6fe&"
import script from "./ProcessTableRow.vue?vue&type=script&lang=js&"
export * from "./ProcessTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports